module.exports = __webpack_public_path__ + "static/benefit-report-eca33b6047895dbb4cbbf218b645bfd0.png";